function o(e) {
  if (typeof e == "object" && e !== null && "value" in e && "message" in e) {
    const { message: n, value: t } = e;
    if (typeof n == "string" && (typeof t == "boolean" || typeof t == "string" || typeof t == "number" || t instanceof RegExp))
      return t;
  }
  return e;
}
export {
  o as e
};
//# sourceMappingURL=extract-rhf-validation-rule-value-DyB3XAHu.mjs.map
